import { addIcons } from "ionicons";

// Import all icons from the ionicons package
import * as icons from "ionicons/icons";

/**
 * You can also import individual icons to decrease the bundle size.
 */
// import { chevronForward, chevronBack } from "ionicons/icons";
//
// const icons = {
//   chevronForward,
//   chevronBack
// };

export function installIcons() {
  // Add all icons to the icon registry
  addIcons(icons);
}
